import { Pagination, Table } from "Components/DataPortal";
import { Filters } from "Components/DataPortal/Filters";
import { Header } from "Components/DataPortal/Header";
import useCustomBranding from "hooks/useCustomBranding";
import { DataPortalTable, TagsTable } from "hooks/useTable";
import React, { useEffect, useLayoutEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { RootState } from "store";
import { IfetchPortals } from "store/dataportal/initialState";
import { fetchDataPortalsAction } from "store/dataportal/reducer.actions";
import { setTagsFiltersAction } from "store/filters";
import { filtersInitialState } from "store/filters/initialState";
import { fetchTagsAction } from "store/tagging";
import { IfetchTags } from "store/tagging/initialState";
import { saveFiltersDataToLocalStorage } from "utils/cacheOrRetriveFiltersDate";
import NoRecordFound from "view/components/NoRecordFound";

export const DataPortal = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const { data, stateIs } = useSelector<RootState, IfetchPortals>(
    (state) => state?.dataPortals
  );

  const { dataPortalFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state?.Filters
  );
  const { primaryColor } = useCustomBranding();


  const {
    flexRender,
    columnVisibility,
    columnOrder,
    columnsConfig,
    table,
    setColumnsConfig,
    setColumnOrder,
    setColumnVisibility,
    setSorting,
    sorting,
  } = DataPortalTable(data?.portals);

  useEffect(() => {
    dispatch(fetchDataPortalsAction());

    saveFiltersDataToLocalStorage(dataPortalFilter);
  }, [dataPortalFilter]);

  return (
    <div className="flex flex-col items-start justify-start w-full pt-4 pb-20">
      <div className="flex flex-col items-start justify-start flex-grow-0 flex-shrink-0 w-full gap-3">
        <Header />
        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 w-full gap-4">
          <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
            <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-2">
              <Filters
                columnOrder={columnOrder}
                setColumnOrder={setColumnOrder}
                columns={columnsConfig}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                setColumnsConfig={setColumnsConfig}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 w-full dark:bg-secondaryLight bg-bgWhite">
          {stateIs === "Idle" && data?.portals?.length === 0 ? (
            <NoRecordFound />
          ) : stateIs === "Pending" ? (
            <div className="loader min-h-[45vh] justify-center items-center flex w-full">
              <TailSpin
                height="50"
                width="50"
                color={primaryColor}
                ariaLabel="tail-spin-loading"
                radius="2"
                wrapperStyle={{}}
                wrapperClass="tailspin-loader"
                visible={true}
              />
            </div>
          ) : (
            <Table
              flexRender={flexRender}
              table={table}
              columnOrder={columnOrder}
              columns={columnsConfig}
              columnVisibility={columnVisibility}
              setSorting={setSorting}
              sorting={sorting}
            />
          )}
          <Pagination />
        </div>
      </div>
    </div>
  );
};
